/**
All risk names. This enum SHOULD eventually be auto-generated as part of the openapi spec,
but can be generated by hand in shell_plus using the following python code:

```python
from textwrap import indent
from typing import get_args
from core.risks.types import RiskName

all_risk_names = sorted(get_args(RiskName))

typescript_enum = (
    "enum APIRiskName {\n" +
    indent("".join([f'{risk_name.upper()} = "{risk_name}",\n' for risk_name in all_risk_names]), prefix=" "*2) +
    "}\n"
)

instructions = r"""
/{asterisk}{asterisk}
All risk names. This enum SHOULD eventually be auto-generated as part of the openapi spec,
but can be generated by hand in shell_plus using the following python code:

{triplebackticks}python
from textwrap import indent
from typing import get_args
from core.risks.types import RiskName

all_risk_names = sorted(get_args(RiskName))

typescript_enum = (
    "enum APIRiskName {{\n" +
    indent("".join([f'{{risk_name.upper()}} = "{{risk_name}}",\n' for risk_name in all_risk_names]), prefix=" "*2) +
    "}}\n"
)

instructions = r{triplequote}{body}{triplequote}

typescript_module = (
    instructions.format(body=instructions, asterisk=chr(42), triplebackticks='```', triplequote='"' + '"' + '"') +
    typescript_enum +
    "\n" +
    "export default APIRiskName;" +
    "\n"
)

print(typescript_module, end="")
{triplebackticks}
{asterisk}/
"""
typescript_module = (
    instructions.format(body=instructions, asterisk=chr(42), triplebackticks='```', triplequote='"' + '"' + '"') +
    typescript_enum +
    "\n" +
    "export default APIRiskName;" +
    "\n"
)

print(typescript_module, end="")
```
*/
enum APIRiskName {
  HAS_ADVERSE_NEWS_MEDIA = "has_adverse_news_media",
  HAS_ALL_INVALID_EMAILS = "has_all_invalid_emails",
  HAS_ALL_VALID_PHONE_NUMBERS = "has_all_valid_phone_numbers",
  HAS_APEX_AND_WWW = "has_apex_and_www",
  HAS_CLOSED_INDICATORS = "has_closed_indicators",
  HAS_CONCERNING_REVIEWS = "has_concerning_reviews",
  HAS_CONCERNINGLY_FEW_EMPLOYEES = "has_concerningly_few_employees",
  HAS_CONCERNINGLY_RECENT_REGISTRATION = "has_concerningly_recent_registration",
  HAS_CONCERNINGLY_RECENT_SUBMITTED_EMAIL = "has_concerningly_recent_submitted_email",
  HAS_CONNECTED_ENTITIES = "has_connected_entities",
  HAS_CUSTOM_PROHIBITED_WEB_CONTENT = "has_custom_prohibited_web_content",
  HAS_DISCOVERABLE_ESTIMATED_ANNUAL_REVENUE = "has_discoverable_estimated_annual_revenue",
  HAS_DISCOVERABLE_ESTIMATED_EMPLOYEE_RANGE = "has_discoverable_estimated_employee_range",
  HAS_DISCOVERABLE_WEB_TRAFFIC = "has_discoverable_web_traffic",
  HAS_EMAIL_DOMAIN_MATCHED = "has_email_domain_matched",
  HAS_EMAIL_DOMAIN_NOT_MATCHED = "has_email_domain_not_matched",
  HAS_EMAIL_REPORTEDLY_USED_IN_FRAUD = "has_email_reportedly_used_in_fraud",
  HAS_FOOT_TRAFFIC_AT_ADDRESS = "has_foot_traffic_at_address",
  HAS_HIGH_REFERRING_SITE_TRAFFIC = "has_high_referring_site_traffic",
  HAS_HIGH_RISK_BRANDS = "has_high_risk_brands",
  HAS_HIGH_RISK_WEB_CONTENT = "has_high_risk_web_content",
  HAS_HIGH_SINGLE_DOMAIN_REFERRING_SITE_TRAFFIC = "has_high_single_domain_referring_site_traffic",
  HAS_HIGH_WEBSITE_BOUNCE_RATE = "has_high_website_bounce_rate",
  HAS_HIGH_WEBSITE_PAID_SEARCH_RATE = "has_high_website_paid_search_rate",
  HAS_HISTORICAL_WEB_PRESENCE = "has_historical_web_presence",
  HAS_HISTORY_OF_DECEPTIVE_APPLICATION_REPORTS = "has_history_of_deceptive_application_reports",
  HAS_HISTORY_OF_DECEPTIVE_BUSINESS_REPORTS = "has_history_of_deceptive_business_reports",
  HAS_LOW_AVERAGE_TIME_ON_SITE = "has_low_average_time_on_site",
  HAS_LOW_GOOGLE_RESULTS_COUNT = "has_low_google_results_count",
  HAS_LOW_TECHNOLOGY_SPEND = "has_low_technology_spend",
  HAS_LOW_WEBSITE_DEVELOPMENT_ACTIVITY = "has_low_website_development_activity",
  HAS_MEANINGFUL_PAID_SEARCH_TRAFFIC = "has_meaningful_paid_search_traffic",
  HAS_MEANINGFUL_TECHNOLOGY_SPEND = "has_meaningful_technology_spend",
  HAS_MEANINGFUL_WEBSITE_DEVELOPMENT_ACTIVITY = "has_meaningful_website_development_activity",
  HAS_MIXED_REPUTATION = "has_mixed_reputation",
  HAS_MULTI_LEVEL_MARKETING_NAME = "has_multi_level_marketing_name",
  HAS_NEGATIVE_REPUTATION = "has_negative_reputation",
  HAS_OPERATING_HISTORY = "has_operating_history",
  HAS_OTHER_TRUEBIZ_SEARCHES = "has_other_truebiz_searches",
  HAS_PERSON_REPORTEDLY_ASSOCIATED_WITH_FRAUD = "has_person_reportedly_associated_with_fraud",
  HAS_PHONE_REPORTEDLY_USED_IN_FRAUD = "has_phone_reportedly_used_in_fraud",
  HAS_POLICY_NO_REFUNDS = "has_policy_no_refunds",
  HAS_POLICY_NOT_TIMELY_REFUNDS = "has_policy_not_timely_refunds",
  HAS_POSITIVE_REPUTATION = "has_positive_reputation",
  HAS_PROHIBITED_BRANDS = "has_prohibited_brands",
  HAS_PROHIBITED_WEB_CONTENT = "has_prohibited_web_content",
  HAS_PROHIBITIVELY_FEW_EMPLOYEES = "has_prohibitively_few_employees",
  HAS_PROHIBITIVELY_RECENT_REGISTRATION = "has_prohibitively_recent_registration",
  HAS_REDIRECTED_DOMAIN = "has_redirected_domain",
  HAS_ROBOTS_TXT = "has_robots_txt",
  HAS_SCRAPING_FAILED = "has_scraping_failed",
  HAS_SOCIAL_LINK_REPORTEDLY_USED_IN_FRAUD = "has_social_link_reportedly_used_in_fraud",
  HAS_SOME_INVALID_EMAILS = "has_some_invalid_emails",
  HAS_SUBSCRIPTIONS = "has_subscriptions",
  HAS_SUFFICIENT_EMPLOYEES = "has_sufficient_employees",
  HAS_VISIBLE_SIGNAGE_AT_ADDRESS = "has_visible_signage_at_address",
  HOMEPAGE_HAS_MINIMAL_CONTENT = "homepage_has_minimal_content",
  IS_ADDRESS_INACTIVE = "is_address_inactive",
  IS_ADDRESS_PO_BOX = "is_address_po_box",
  IS_ADDRESS_RESIDENTIAL = "is_address_residential",
  IS_ADDRESS_VACANT = "is_address_vacant",
  IS_ADDRESS_VIRTUAL = "is_address_virtual",
  IS_COMPANY_SIZE_AND_REVENUE_METRICS_ALIGNED = "is_company_size_and_revenue_metrics_aligned",
  IS_COMPANY_SIZE_AND_REVENUE_METRICS_NOT_ALIGNED = "is_company_size_and_revenue_metrics_not_aligned",
  IS_COUNTRY_HIGH_RISK = "is_country_high_risk",
  IS_COUNTRY_PROHIBITED = "is_country_prohibited",
  IS_DEFAULT_SOCIAL_MEDIA_LINK_PRESENT = "is_default_social_media_link_present",
  IS_DOMAIN_REGISTRAR_NEAR_BUSINESS_LOCATION = "is_domain_registrar_near_business_location",
  IS_FOUNDED_RECENTLY = "is_founded_recently",
  IS_HOSTING_PROVIDER_IN_HIGH_RISK_COUNTRY = "is_hosting_provider_in_high_risk_country",
  IS_HOSTING_PROVIDER_IN_PROHIBITED_COUNTRY = "is_hosting_provider_in_prohibited_country",
  IS_INDUSTRY_CLASSIFIED = "is_industry_classified",
  IS_INDUSTRY_ELEVATED_RISK = "is_industry_elevated_risk",
  IS_INDUSTRY_HIGH_RISK = "is_industry_high_risk",
  IS_INDUSTRY_PROHIBITED = "is_industry_prohibited",
  IS_KNOWN_FREE_EMAIL_HOST = "is_known_free_email_host",
  IS_KNOWN_HOSTING_PROVIDER_DOMAIN = "is_known_hosting_provider_domain",
  IS_KNOWN_LINK_SHORTENER_DOMAIN = "is_known_link_shortener_domain",
  IS_KNOWN_MARKETPLACE_DOMAIN = "is_known_marketplace_domain",
  IS_KNOWN_SOCIAL_MEDIA_DOMAIN = "is_known_social_media_domain",
  IS_KNOWN_TOP_DOMAIN = "is_known_top_domain",
  IS_LONG_REGISTRATION = "is_long_registration",
  IS_NO_SOCIAL_MEDIA_PROFILES_FOUND = "is_no_social_media_profiles_found",
  IS_NON_BUSINESS_DOMAIN_TLD = "is_non_business_domain_tld",
  IS_NOT_REGISTERED = "is_not_registered",
  IS_NOT_RESOLVABLE = "is_not_resolvable",
  IS_PARKED = "is_parked",
  IS_PLACEHOLDER_TEXT_PRESENT = "is_placeholder_text_present",
  IS_PRIMARY_PHONE_NUMBER_INACTIVE = "is_primary_phone_number_inactive",
  IS_PRIMARY_PHONE_NUMBER_INVALID = "is_primary_phone_number_invalid",
  IS_PRIMARY_PHONE_NUMBER_LINKED_TO_COMPANY = "is_primary_phone_number_linked_to_company",
  IS_PRIMARY_PHONE_NUMBER_TYPE_SUSPICIOUS = "is_primary_phone_number_type_suspicious",
  IS_PRIMARY_TRAFFIC_FROM_HIGH_RISK_COUNTRY = "is_primary_traffic_from_high_risk_country",
  IS_PRIMARY_TRAFFIC_FROM_PROHIBITED_COUNTRY = "is_primary_traffic_from_prohibited_country",
  IS_PRIVACY_POLICY_SUSPICIOUS = "is_privacy_policy_suspicious",
  IS_REGISTERED_AGENT_ADDRESS = "is_registered_agent_address",
  IS_REGISTRAR_IN_HIGH_RISK_COUNTRY = "is_registrar_in_high_risk_country",
  IS_REGISTRAR_IN_PROHIBITED_COUNTRY = "is_registrar_in_prohibited_country",
  IS_REGISTRATION_EXPIRATION_CONCERNINGLY_SOON = "is_registration_expiration_concerningly_soon",
  IS_REGISTRATION_EXPIRATION_PROHIBITIVELY_SOON = "is_registration_expiration_prohibitively_soon",
  IS_REGISTRATION_EXPIRED = "is_registration_expired",
  IS_REGISTRATION_UPDATED_CONCERNINGLY_RECENTLY = "is_registration_updated_concerningly_recently",
  IS_REGISTRATION_UPDATED_PROHIBITIVELY_RECENTLY = "is_registration_updated_prohibitively_recently",
  IS_SHORT_REGISTRATION = "is_short_registration",
  IS_SOCIAL_MEDIA_PROFILES_FOUND = "is_social_media_profiles_found",
  IS_SSL_INVALID = "is_ssl_invalid",
  IS_SUBMITTED_ADDRESS_COUNTRY_HIGH_RISK = "is_submitted_address_country_high_risk",
  IS_SUBMITTED_ADDRESS_COUNTRY_PROHIBITED = "is_submitted_address_country_prohibited",
  IS_SUBMITTED_ADDRESS_INACTIVE = "is_submitted_address_inactive",
  IS_SUBMITTED_ADDRESS_PO_BOX = "is_submitted_address_po_box",
  IS_SUBMITTED_ADDRESS_RESIDENTIAL = "is_submitted_address_residential",
  IS_SUBMITTED_ADDRESS_VACANT = "is_submitted_address_vacant",
  IS_SUBMITTED_ADDRESS_VIRTUAL = "is_submitted_address_virtual",
  IS_SUBMITTED_EMAIL_FROM_DISPOSABLE_HOST = "is_submitted_email_from_disposable_host",
  IS_SUBMITTED_EMAIL_FROM_KNOWN_FREE_HOST = "is_submitted_email_from_known_free_host",
  IS_SUBMITTED_EMAIL_INVALID = "is_submitted_email_invalid",
  IS_SUBMITTED_PHONE_INVALID = "is_submitted_phone_invalid",
  IS_SUBMITTED_PHONE_TYPE_SUSPICIOUS = "is_submitted_phone_type_suspicious",
  IS_SUBMITTED_REGISTERED_AGENT_ADDRESS = "is_submitted_registered_agent_address",
  IS_UNDER_CONSTRUCTION = "is_under_construction",
  IS_UNEXPECTED_CURRENCY_CODE = "is_unexpected_currency_code",
  IS_UNEXPECTED_LANGUAGE = "is_unexpected_language",
  IS_WEBSERVER_NONRESPONSIVE = "is_webserver_nonresponsive",
  IS_WEBSITE_CONTENT_DUPLICATED = "is_website_content_duplicated",
  IS_WEBSITE_HOSTING_PROVIDER_NEAR_BUSINESS_LOCATION = "is_website_hosting_provider_near_business_location",
  MIXED_REVIEW_SENTIMENT = "mixed_review_sentiment",
  REVIEWS_ENGAGEMENT = "reviews_engagement",
  SOCIAL_MEDIA_ENGAGEMENT = "social_media_engagement",
  SUBMITTED_ADDRESS_HAS_BUSINESS_CONNECTIONS = "submitted_address_has_business_connections",
  SUBMITTED_DESCRIPTION_DOES_NOT_MATCH_BUSINESS = "submitted_description_does_not_match_business",
  SUBMITTED_EMAIL_DOMAIN_DOES_NOT_MATCH_BUSINESS_DOMAIN = "submitted_email_domain_does_not_match_business_domain",
  SUBMITTED_EMAIL_HAS_BUSINESS_CONNECTIONS = "submitted_email_has_business_connections",
  SUBMITTED_PERSON_HAS_BUSINESS_CONNECTIONS = "submitted_person_has_business_connections",
  SUBMITTED_PHONE_HAS_BUSINESS_CONNECTIONS = "submitted_phone_has_business_connections",
}

export default APIRiskName;
